import styled from 'styled-components';

/** Área única onde o loading e o conteúdo da página dinâmica são exibidos (evita loading fora de contexto). */
export const DynamicPageContent = styled.div`
  width: 100%;
  min-height: 400px;
`;

export const LoadingPlaceholder = styled.div`
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-neutral-light-lighter, #f5f5f5);
  width: 100%;
`;

